import {Service} from "vue-typedi";
import scanSound from '@/assets/sounds/scan.mp3';
import errorSound from '@/assets/sounds/error.mp3';

@Service()
export class PlaybackService {
    private static readonly SCAN_SOUND: HTMLAudioElement = new Audio(scanSound);
    private static readonly ERROR_SOUND: HTMLAudioElement = new Audio(errorSound);

    public play(sound: Sound): void {
        const audio = this.findSound(sound);
        if (sound == null) {
            return;
        }

        audio.play();
    }

    private findSound(sound: Sound): HTMLAudioElement {
        switch (sound) {
            case Sounds.SCAN:
                return PlaybackService.SCAN_SOUND;
            case Sounds.ERROR:
                return PlaybackService.ERROR_SOUND;
            default:
                return null;
        }
    }
}

export enum Sounds {
    SCAN = 'SCAN',
    ERROR = 'ERROR'
}

type Sound = Sounds.SCAN | Sounds.ERROR;
